








import { Component, Vue, Emit, Prop } from 'vue-property-decorator';

@Component
export default class Btn extends Vue {
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) skip!: boolean;

  @Emit('click')
  handleClick() {}
}
